import styled from "styled-components"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { Password } from "primereact/password"
import { Image } from "primereact/image"
import React from "react"

export const StButton = styled(Button)`
  background-color: var(--bg-color);
  padding: 0.2rem 0.5rem;
  border: none;
  &:hover {
    background-color: #f3f3f3;
  }
  font-size: 1rem;
`

export const StInputText = styled(InputText)`
  padding: 0.2rem 0.5rem;
  border-width: 0px 0px 1px 0px;
  font-size: 1rem;
`

export const StPassword = styled(Password)`
  & > input {
    padding: 0.2rem 0.5rem;
    border-width: 0px 0px 1px 0px;
    font-size: 1rem;
  }
`

export const Container = styled.div`
  border-width: 1px;
  border-color: #ebebeb;
  border-style: solid;
  padding: 0.5rem;
`

export const FlexV = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;
  overflow: auto;
`

export const FlexH = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 0.5rem;
  overflow: auto;
`

export const StImage = styled(Image)``

export const LineH = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <div style={{ height: "1px", ...style }}>
      <svg
        viewBox="0 0 100 1"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
        }}
      >
        <path
          d="M0,0.5 L100,0.5"
          style={{
            strokeWidth: "1",
            stroke: "#000000",
            vectorEffect: "non-scaling-stroke",
          }}
        ></path>
      </svg>
    </div>
  )
}

export const LineV = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <div style={{ width: "1px", ...style }}>
      <svg
        viewBox="0 0 1 100"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
        }}
      >
        <path
          d="M0.5,0 L0.5,100"
          style={{
            strokeWidth: "1",
            stroke: "#000000",
            vectorEffect: "non-scaling-stroke",
          }}
        ></path>
      </svg>
    </div>
  )
}
